export const EDITPHONE_FILE = 'EDITPHONE_FILE';
// 更新
export const EDITPHONE_UPDATE = 'EDITPHONE_UPDATE';
